import React from "react";
import SectionPage from "@/components/SectionPage";

export default function Events() {
  return <SectionPage sectionKey="events" />;
}
